import { render, staticRenderFns } from "./fxServiceNumTable.vue?vue&type=template&id=420394f0"
import script from "./fxServiceNumTable.vue?vue&type=script&lang=js"
export * from "./fxServiceNumTable.vue?vue&type=script&lang=js"
import style0 from "./fxServiceNumTable.vue?vue&type=style&index=0&id=420394f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports